import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwipeToCloseDirective } from '../directives/swipe-to-close.directive';

@NgModule({
  declarations: [SwipeToCloseDirective],
  imports: [CommonModule],
  exports: [SwipeToCloseDirective],
})
export class SharedDirectivesModule {}
